import { Component } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { DbService } from 'src/app/services/db-service/db.service';
import { TemplateService } from 'src/app/services/template.service';
import { ForgotPasswordComponent } from '../forgot-password/forgot-password.component';
import Swal from 'sweetalert2';
import { SocialAuthService } from '@abacritt/angularx-social-login';
import { Subscription } from 'rxjs';
import { Industry, StorageKeys } from 'src/app/shared-module-files/simpo.constant';
import { environment } from 'src/environments/environment';
import { DeviceDetectorService } from 'ngx-device-detector';
import { StaffServiceService } from 'src/app/master-config-components/micro-apps/staff/service/staff-service.service';
import { SubscriptionService } from 'src/app/services/subscription.service';
import { EventEmmiterService } from 'src/app/services/event-emmiter.service';
import { EcommerceService } from 'src/app/services/ecommerce.service';

export enum FormType {
  "SIGN_UP" = "SIGN_UP",
  "LOGIN" = "LOGIN"
}

@Component({
  selector: 'app-signin-signup',
  templateUrl: './signin-signup.component.html',
  styleUrls: ['./signin-signup.component.scss', './mq-signin-signup.component.scss']
})
export class SigninSignupComponent {
  // };
  updatingObject = {
    id: '',
    websiteUrl: ''
  };

  // businessDetails: any = {
  //   businessName: '',
  //   phoneNumber: '',
  //   email: '',
  //   businessType: '',
  //   city: '',
  //   address: '',
  //   checked: true,
  emailRegex = new RegExp('[a-z0-9]+@[a-z]+\.[a-z]{2,3}');
  businessForm: any = 'loginDetails';
  edit: any;
  loader: boolean = false;
  websiteId: string = '';
  countryCodes: any[] = [];
  selectedCountry: any;
  formType: FormType = FormType.SIGN_UP;
  checkedColor = '#025eb0'
  googleUser: any;
  loggedIn: any
  lowercase: string = "";
  disableDropdown: boolean = false;
  disableCountryCodeDropdown: boolean = false;
  selectedIndustry: Industry = {
    name: '',
    industryId: '',
    industryName: '',
    subIndustryId: '',
    subIndustryName: ''
  }
  //signup
  signupForm: FormGroup = new FormGroup({
    name: new FormControl('', [Validators.required]),
    dialCode: new FormControl('', [Validators.required]),
    mobileNumber: new FormControl('', [Validators.required, Validators.maxLength(15)]),
    email: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$')]),
    password: new FormControl('', [Validators.required, Validators.minLength(8), this.validatePassword()]),
  });
  signupHide = true;
  signinHide = true;
  //signin
  signInForm: FormGroup = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$')]),
    password: new FormControl('', [Validators.required, Validators.minLength(8)]),
    rememberMe: new FormControl(false)
  });
  showToolTip: boolean = false;
  private authSubscription: Subscription | undefined;

  constructor(
    private router: Router,
    private authService: AuthServiceService,
    private templateService: TemplateService,
    private _dbService: DbService,
    private SocialAuthService: SocialAuthService,
    private deviceService: DeviceDetectorService,
    private staffService: StaffServiceService,
    private subscriptionService: SubscriptionService,
    private eventService: EventEmmiterService,
    private ecommerceService: EcommerceService,
  ) {
  }

  activeTab: string = 'NEW_FLOW'; // Default to 'old' tab
  tabs = [
    { id: 'OLD_FLOW', label: 'Old Flow' },
    { id: 'NEW_FLOW', label: 'New Flow' }
  ];

  // Add this method to handle tab switching
  switchTab(tabId: string): void {
    this.activeTab = tabId;
    localStorage.setItem('selectedFlowTab', tabId);
    console.log('Tab switched to:', tabId);
  }




  onEmailChange(event) {
    this.signInForm.controls["email"].setValue(event.target.value.toLowerCase());
    this.signupForm.controls["email"].setValue(event.target.value.toLowerCase());
  }

  ngOnInit() {
    let deviceInfo = this.deviceService.getDeviceInfo();
    //
    if (this._dbService.getBusinessId() != null) {
      this.router.navigate([`/admin/home`]);
    }

    const savedTab = localStorage.getItem('selectedFlowTab');
    if (savedTab) {
      this.activeTab = savedTab;
    }

    if (sessionStorage.getItem('remember') === null) {
      this.signInForm.get('rememberMe')?.setValue(false);
    } else {
      let remember = sessionStorage.getItem('remember');
      if (remember === 'true') {
        this.signInForm.get('rememberMe')?.setValue(true);
        let mailId = sessionStorage.getItem('eucpviqc')
        if (!mailId) return;
        let pwd = sessionStorage.getItem('fox')
        if (!pwd) return;

        this.signInForm.get('email')?.setValue(atob(mailId));
        this.signInForm.get('password')?.setValue(atob(pwd));
      } else {
        this.signInForm.get('rememberMe')?.setValue(false);
      }
    }

    this.websiteId = localStorage.getItem(StorageKeys.WEBSITE_ID) || '';

    const industry = localStorage.getItem(StorageKeys.INDUSTRY_DETAILS);
    this.selectedIndustry = industry ? JSON.parse(industry) : this.selectedIndustry;

    const currentUrl = this.router.url.split('/')[1];


    if (currentUrl === 'signup') {
      this.formType = FormType.SIGN_UP;
    } else {
      this.formType = FormType.LOGIN;
    }
    if (localStorage.getItem(StorageKeys.GOOGLETOKENID)) {
      this.SocialAuthService.signOut().then((res) => {
      })
      localStorage.removeItem(StorageKeys.GOOGLETOKENID);
    }
    this.getAllCountries();

    this.triggerGoogleSignin()
  }

  triggerGoogleSignin() {
    this.authSubscription = this.SocialAuthService.authState.subscribe((user) => {
      this.googleUser = user;
      this.loggedIn = (user != null);
      if (this.googleUser) {
        this.login()
      }
    })
  }

  ngOnDestroy() {
    this.authSubscription?.unsubscribe();
  }

  /** Minimal offline list so signup never blocks when the country API is down. */
  private static readonly FALLBACK_COUNTRY_CODES = [
    { name: 'India', shortCode: 'IN', dialingCode: '+91' },
    { name: 'United States', shortCode: 'US', dialingCode: '+1' },
    { name: 'United Kingdom', shortCode: 'GB', dialingCode: '+44' },
    { name: 'United Arab Emirates', shortCode: 'AE', dialingCode: '+971' },
    { name: 'Australia', shortCode: 'AU', dialingCode: '+61' },
    { name: 'Canada', shortCode: 'CA', dialingCode: '+1' },
    { name: 'Singapore', shortCode: 'SG', dialingCode: '+65' },
  ];

  getAllCountries() {
    this.authService.getAllCountries().subscribe(
      (res: any) => {
        const list = res?.data?.data ?? [];
        this.applyCountryCodes(list.length ? list : SigninSignupComponent.FALLBACK_COUNTRY_CODES);
      },
      (err) => {
        // Country master data is public/reference — don't block signup if it fails.
        this.applyCountryCodes(SigninSignupComponent.FALLBACK_COUNTRY_CODES);
      }
    )
  }

  private applyCountryCodes(list: any[]) {
    this.countryCodes = list || [];

    const shortCode = localStorage.getItem(StorageKeys.SHORT_CODE);
    const dialCode = localStorage.getItem(StorageKeys.dialCodeDropdown) === 'true';

    let shortCodeIndex = shortCode
      ? this.countryCodes.findIndex((c: any) => c.shortCode?.toLowerCase() === shortCode.toLowerCase())
      : this.countryCodes.findIndex((c: any) => c.shortCode?.toLowerCase() === 'in');

    if (shortCodeIndex < 0) shortCodeIndex = 0;

    if (shortCodeIndex > -1 && this.countryCodes[shortCodeIndex]) {
      this.selectedCountry = this.countryCodes[shortCodeIndex];
      this.signupForm.get('dialCode')?.setValue(this.countryCodes[shortCodeIndex].shortCode);
      this.disableCountryCodeDropdown = !!dialCode;
    }
  }

  signIn() {
    this.router.navigate(['/admin/website/preview']);
  }

  redirectToSignup() {
    if (this.activeTab === 'OLD_FLOW') {
      if (localStorage.getItem(StorageKeys.INDUSTRY_DETAILS) != null) {
        this.router.navigate(['/signup']);
      } else {
        // this.router.navigate(['/website-type'])
        this.router.navigate(['/onboarding'])
        // this.eventService.onBoardingRedirect.emit({ 'redirectionUrl': '' })
      }
    } else {
      this.router.navigate(['/signup']);
    }
  }

  redirectToSignIn() {
    this.formType = FormType.LOGIN;
  }

  redirectFromSignin() {
    window.location.href = environment.mainFrameUrl;
    // this.router.navigate([''])

  }

  login() {
    var data;
    this.loader = true;
    if (this.googleUser) {
      data = {
        businessName: localStorage.getItem(StorageKeys.BUSINESS_NAME),
        contact: {
          email: this.googleUser.email
        },
        address: {
          city: localStorage.getItem(StorageKeys.LOCALITY),
          state: localStorage.getItem(StorageKeys.STATE) ?? 'Telangana',
          country: localStorage.getItem(StorageKeys.COUNTRY) ?? 'india',
          geolocation: {
            latitude: localStorage.getItem(StorageKeys.LATITUDE),
            longitude: localStorage.getItem(StorageKeys.LONGITUDE)
          }
        },
        industryName: this.selectedIndustry.industryName,
        industryId: this.selectedIndustry.industryId,
        subIndustryId: this.selectedIndustry.subIndustryId,
        subIndustryName: this.selectedIndustry.subIndustryName,
        userName: this.googleUser.email.toLowerCase(),
        name: this.googleUser.name,
        templateId: this.websiteId,
        countryId: this.selectedCountry?.id ?? '',
        countryCode: this.selectedCountry?.shortCode ?? '',
        googleToken: this.googleUser ? this.googleUser.idToken : null,
        websiteStatus: localStorage.getItem(StorageKeys.WEBSITE_STATUS),
        affiliatePartnerKey: null
      }
    } else if (this.websiteId) {
      data = {
        businessName: localStorage.getItem(StorageKeys.BUSINESS_NAME),
        address: {
          city: localStorage.getItem(StorageKeys.LOCALITY),
          state: localStorage.getItem(StorageKeys.STATE) ?? 'Telangana',
          country: localStorage.getItem(StorageKeys.COUNTRY) ?? 'india',
          geolocation: {
            latitude: localStorage.getItem(StorageKeys.LATITUDE),
            longitude: localStorage.getItem(StorageKeys.LONGITUDE)
          }
        },
        industryName: this.selectedIndustry.industryName,
        industryId: this.selectedIndustry.industryId,
        subIndustryId: this.selectedIndustry.subIndustryId,
        subIndustryName: this.selectedIndustry.subIndustryName,
        userName: this.signInForm.value.email.toLowerCase(),
        pwd: this.signInForm.value.password,
        templateId: this.websiteId,
        countryId: this.selectedCountry?.id ?? '',
        countryCode: this.selectedCountry?.shortCode ?? '',
        websiteStatus: localStorage.getItem(StorageKeys.WEBSITE_STATUS)
      }
    } else {
      data = {
        userName: this.signInForm.value.email.toLowerCase(),
        pwd: this.signInForm.value.password,
      }
    }

    if (this.googleUser) {
      if (localStorage.getItem("partnerId")) {
        data.affiliatePartnerKey = localStorage.getItem("partnerId")
      }
    }

    this.authService.login(data).subscribe(
      (res: any) => {

        if (res.data === 'New Google User Found') {
          localStorage.setItem(StorageKeys.GOOGLETOKENID, this.googleUser.idToken);
          localStorage.setItem("countryCode", this.selectedCountry?.shortCode);
          localStorage.setItem("countryId", this.selectedCountry?.id);
          if (this.activeTab === 'OLD_FLOW') {
            this.router.navigate(['/website-type']);
          } else {
            this.router.navigate(['/onboarding/industry-selection']);
          }
          // this.router.navigate(['/website-type']);
          //  this.router.navigate(['/onboarding'])
          return;
        }

        localStorage.setItem(StorageKeys.STAFF_ID, res.data.id);
        localStorage.setItem(StorageKeys.STAFF_NAME, res.data.name);
        localStorage.setItem(StorageKeys.STAFF_EMAIL, res.data?.contact?.email);
        localStorage.setItem(StorageKeys.LOGGED_IN_USER, JSON.stringify(res.data));
        localStorage.setItem("Mobile", res.data?.contact?.mobile);
        localStorage.setItem("countryCode", res.data?.contact?.countryCode);
        localStorage.setItem(StorageKeys.token, res.data.token);
        if (res.data.expiresIn != null) {
          localStorage.setItem(
            StorageKeys.ACCESS_TOKEN_EXPIRES_AT,
            String(Date.now() + Number(res.data.expiresIn) * 1000),
          );
        }
        if (res.data.refreshToken) {
          localStorage.setItem(StorageKeys.REFRESH_TOKEN, res.data.refreshToken);
        }
        // The login access token is scoped to business[0]; record it so
        // ensureBusinessSession() knows a switch is needed for any other business.
        if (res.data.business?.length) {
          localStorage.setItem('tokenBusinessId', res.data.business[0].id);
        }

        this._dbService.setFname(res.data.name)
        // No business yet -> straight to onboarding so the user can create one.
        // Guard against business being null/undefined (not just []).
        if (!res.data.business || res.data.business.length === 0) {
          if (this.activeTab === 'OLD_FLOW') {
            this.router.navigate(['/website-type']);
            this.loader = false;
            return;
          } else {
            this.router.navigate(['/onboarding/industry-selection']);
            this.loader = false;
            return;
          }

        } else {
          localStorage.setItem(StorageKeys.BUSINESS_NAME, res.data.business[0].name);
          window.localStorage.setItem('business', JSON.stringify(res.data.business));
          localStorage.setItem(StorageKeys.SUBINDUSTRYID, this.selectedIndustry.subIndustryId);
        }




        // localStorage.setItem("countryCode", data.countryCode);
        // localStorage.setItem("countryId", data.countryId);

        // const selectedBusinessName = localStorage.getItem(StorageKeys.BUSINESS_NAME);

        // if (selectedBusinessName) {
        //   this.router.navigate(['v2-generator']);
        // } else
        if (window.localStorage.getItem('EXISTING') === 'YES') {
          localStorage.removeItem("EXISTING");
          res.data.business.forEach(element => {
            if (((element.name).toLowerCase()).split(' ').join('_') === ((data.businessName).toLowerCase()).split(' ').join('_')) {
              this.getBusinessDetailsById(element.id);
              // this.getStaffPermission(res.data.id, element.id)
              this.getCurrencySymbol(element.id);
              this._dbService.setBusinessId(element.id);
            }
            // else{
            //   element.favourite = false;
            // }
          });
          // let a = res.data.business.find(e => e.favourite);
        } else {
          if (res.data.business.length === 1) {
            this._dbService.setBusinessId(res.data.business[0].id);
            this.getBusinessDetailsById(res.data.business[0].id);
            // this.getStaffPermission(res.data.id, res.data.business[0].id)
            this.getCurrencySymbol(res.data.business[0].id);
          } else {
            let a = res.data.business.find(e => e.favourite);
            if (this.websiteId) {
              this._dbService.setBusinessId(res.data.business[res.data.business.length - 1].id);
              this.getBusinessDetailsById(res.data.business[res.data.business.length - 1].id);
              // this.getStaffPermission(res.data.id, res.data.business[res.data.business.length - 1].id)
              this.getCurrencySymbol(res.data.business[0].id);
            } else if (a) {
              this.getBusinessDetailsById(a.id);
              // this.getStaffPermission(res.data.id, a.id)
              this.getCurrencySymbol(a.id);
              this._dbService.setBusinessId(a.id);
            } else {
              this.router.navigate(['/list-business']);
            }
          }
        }

        if (this.signInForm.get('rememberMe')?.value) {
          sessionStorage.setItem('eucpviqc', btoa((this.signInForm.value.email).toLowerCase()));
          sessionStorage.setItem('fox', btoa(this.signInForm.value.password));
          sessionStorage.setItem('remember', `${this.signInForm.get('rememberMe')?.value}`);
        } else {
          sessionStorage.setItem('remember', `${this.signInForm.get('rememberMe')?.value}`);
          sessionStorage.clear();
        }

      },
      (err) => {
        this.loader = false;
        this.templateService.openSnack(`${err.error.message}`, 'Close')
      }
    );
  }

  // getStaffPermission(staffId: any, businessId: any, businessType: any) {
  //   this.staffService.getStaffPermissionByStaffId(staffId, businessId).subscribe((res: any) => {
  //     localStorage.setItem(StorageKeys.PERMISSIONS, JSON.stringify(res.data));

  //     this.subscriptionService.changeCurrentPlanDetails();
  //     this.subscriptionService.openPricingModal();

  //     if (!businessType || businessType == 'STATIC')
  //       this.router.navigate(['/admin/home']);
  //     else
  //       this.router.navigate(['/admin/products/list-products']);
  //     this.loader = false;
  //   }, (err) => {
  //     this.loader = false;
  //   })
  // }

  replaceUnderscoresInKeys(obj: any): any {
    if (Array.isArray(obj)) {
      return obj.map(item => this.replaceUnderscoresInKeys(item));
    } else if (obj !== null && typeof obj === 'object') {
      const newObj: any = {};
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          const newKey = key.replace(/_/g, ' ');
          newObj[newKey] = this.replaceUnderscoresInKeys(obj[key]);
        }
      }
      return newObj;
    }
    return obj;
  }

  getStaffPermission(staffId: any, businessId: any, businessType: any) {
    this.staffService.setPermissionsFromBusinessList(businessId);

    this.subscriptionService.changeCurrentPlanDetails();
    this.subscriptionService.openPricingModal();

    if (businessId == '1f0ed406-435f-6707-ae3b-15b2ffc0a765') {
      this.router.navigate(['/admin/crm/list-leads']);
      this.loader = false;
      return;
    }

    let bDetails = JSON.parse(localStorage.getItem('bDetails') || '{}');
    if (!bDetails?.configs?.removeHome) {
      if (!businessType || businessType == 'STATIC') {
        this.router.navigate(['/admin/home']);
      } else {
        this.router.navigate(['/admin/products/list-products']);
      }
    } else {
      this.router.navigate([`${bDetails?.configs?.redirectionUrl || '/admin/home'}`]);
    }

    this.loader = false;
  }




  createAnAccount() {
    this.loader = true;

    let data: any = {
      businessName: localStorage.getItem(StorageKeys.BUSINESS_NAME),
      contact: {
        mobile: this.signupForm.value.mobileNumber,
        email: this.signupForm.value.email,
        countryCode: this.signupForm.value.dialCode,
        name: this.signupForm.value.name
      },
      address: {
        city: localStorage.getItem(StorageKeys.LOCALITY) ?? "Hyderabad",
        state: localStorage.getItem(StorageKeys.STATE) ?? 'Telangana',
        geolocation: {
          latitude: localStorage.getItem(StorageKeys.LATITUDE) ?? "17.360589",
          longitude: localStorage.getItem(StorageKeys.LONGITUDE) ?? "78.474061"
        }
      },
      industryName: this.selectedIndustry.industryName,
      industryId: this.selectedIndustry.industryId,
      subIndustryId: this.selectedIndustry.subIndustryId,
      subIndustryName: this.selectedIndustry.subIndustryName,
      name: this.signupForm.value.name,
      pwd: this.signupForm.value.password,
      templateId: this.websiteId,
      countryId: this.selectedCountry.id,
      countryCode: this.selectedCountry.shortCode,
      websiteStatus: localStorage.getItem(StorageKeys.WEBSITE_STATUS),
      affiliatePartnerKey: ""
    }
    if (localStorage.getItem("partnerId")) {
      data.affiliatePartnerKey = localStorage.getItem("partnerId")
    }
    this.authService.createAccount(data).subscribe(
      (res: any) => {
        this._dbService.setBusinessId(res.data.business[0].id)
        this._dbService.setFname(res.data.name);
        window.localStorage.setItem('business', JSON.stringify(res.data.business));
        this.getCurrencySymbol(res.data.business[0].id);
        localStorage.setItem(StorageKeys.STAFF_ID, res.data.id);
        localStorage.setItem(StorageKeys.STAFF_NAME, res.data.name);
        localStorage.setItem(StorageKeys.STAFF_EMAIL, res.data?.contact?.email);
        localStorage.setItem(StorageKeys.SUBINDUSTRYID, this.selectedIndustry.subIndustryId);
        // this.getStaffPermission(res.data.id, res.data.business[0].id);

        localStorage.setItem("countryCode", data.countryCode);
        localStorage.setItem("countryId", data.countryId);

        // const selectedBusinessName = localStorage.getItem(StorageKeys.BUSINESS_NAME);

        // if (selectedBusinessName) {
        //   this.router.navigate(['v2-generator']);
        // } else {
        this.getBusinessDetailsById(res.data.business[0].id);
        // }
      },
      (err) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: err.error.message
        });
        this.loader = false;
      }
    )
  }

  createAnAccountNew() {
    this.loader = true;

    let request = {
      name: this.signupForm.value.name,
      email: this.signupForm.value.email,
      countryCode: this.signupForm.value.dialCode,
      mobile: this.signupForm.value.mobileNumber,
      password: this.signupForm.value.password,
    }

    this.authService.createAccountv2(request).subscribe(
      (res: any) => {
        this._dbService.setFname(res.data.name);
        localStorage.setItem(StorageKeys.STAFF_ID, res.data.id);
        localStorage.setItem(StorageKeys.STAFF_NAME, res.data.name);
        localStorage.setItem(StorageKeys.STAFF_EMAIL, res.data?.contact?.email);
        localStorage.setItem(StorageKeys.SUBINDUSTRYID, this.selectedIndustry.subIndustryId);
        localStorage.setItem(StorageKeys.LOGGED_IN_USER, JSON.stringify(res.data));
        localStorage.setItem("Mobile", res.data?.contact?.mobile);
        // this.getStaffPermission(res.data.id, res.data.business[0].id);

        localStorage.setItem("countryCode", request.countryCode);
        localStorage.setItem("countryId", request.countryCode);

        // const selectedBusinessName = localStorage.getItem(StorageKeys.BUSINESS_NAME);

        // if (selectedBusinessName) {
        //   this.router.navigate(['v2-generator']);
        // } else {
        if (res.data.business.length === 0) {
          this.router.navigate(['/onboarding/industry-selection'])
          this.loader = false;
          return;
        } else {
          this._dbService.setBusinessId(res.data.business[0].id)
          window.localStorage.setItem('business', JSON.stringify(res.data.business));
          this.getCurrencySymbol(res.data.business[0].id);
          this.getBusinessDetailsById(res.data.business[0].id);
        }

        // }
      },
      (err) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: err.error.message
        });
        this.loader = false;
      }
    )
  }

  getCurrencySymbol(bId: any) {
    this.authService.getCurrencySymbol(bId).subscribe({
      next: (value: any) => {
        this._dbService.setBusinessPrefernce(JSON.stringify(value.data));
      }
    })
  }

  getBusinessDetailsById(bId: any) {
    // The login token is scoped to business[0]. If we're landing on any other
    // business, switch the session first so the details call isn't rejected (403).
    this.authService.ensureBusinessSession(bId).subscribe({
      next: () => this.fetchBusinessDetails(bId),
      error: () => this.fetchBusinessDetails(bId),
    });
  }

  private fetchBusinessDetails(bId: any) {
    this.authService.getDetailsByBusinessId(bId).subscribe(
      (res: any) => {
        window.localStorage.setItem('bDetails', JSON.stringify(res.data.business));
        localStorage.setItem('subIndustryName', res.data.business.subIndustryName);
        // 'type' is set inside getStaffPermission based on actual admin status
        this.getStaffPermission(localStorage.getItem(StorageKeys.STAFF_ID), bId, res.data.business.type);
        this.ecommerceFeatures(bId);
      },
      (err) => {
        this.loader = false;
      }
    )
  }

  ecommerceFeatures(businessId: string) {
    this.ecommerceService.getEcomSettings(businessId).subscribe({
      next: (res: any) => {
        if (res.data) {
          localStorage.setItem('isMaterialBasedPricing', res.data.materialBasedPricing);
        }
      },
      error: (err) => {
        this.staffService.openSnack('Error fetching ecommerce settings', 'Close',);
      }
    });
  }

  goBackToPreviousPage() {
    if (this.websiteId) {
      this.router.navigate([`v3-generator`]);
    } else {
      this.router.navigate(['/']);
    }
  }

  privacyPolicy() {
    // this.router.navigate(['/privacy-policy']);
    window.open(`${environment.redirectingOtherSite}/privacy-policy`, '_blank');
  }

  termsConditions() {
    // this.router.navigate(['/terms-conditions'])
    window.open(`${environment.redirectingOtherSite}/terms-conditions`, '_blank');
  }

  hide() {
    this.showToolTip = false;
  }

  forgotPassword() {
    this.templateService.openDialog(
      ForgotPasswordComponent,
      'auto',
      '540px',
      '80vw'
    )
  }

  private validatePassword(): ValidatorFn {
    return (c: AbstractControl): ValidationErrors | null => {
      const oneLetterCapitalPattern = new RegExp(/[A-Z]/g);
      const oneSymbolPattern = new RegExp(/[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/g);
      const oneNumberPattern = new RegExp(/[0-9]/g);

      const errorObj = {
        oneLetterCapital: oneLetterCapitalPattern.test(c.value),
        oneSymbolPattern: oneSymbolPattern.test(c.value),
        oneNumberPattern: oneNumberPattern.test(c.value),
        minimumLength: c.value.length >= 8
      }

      if (!errorObj.minimumLength || !errorObj.oneLetterCapital || !errorObj.oneNumberPattern || !errorObj.oneSymbolPattern) {
        return errorObj;
      }

      return null;
    }
  }



  features = [
    {
      title: "AI Website Builder",
      description: "Build websites under minutes",
      icon: "https://d2z9497xp8xb12.cloudfront.net/prod-images/374501c1762793495744🌐.svg"
    },
    {
      title: "AI Blog Writer",
      description: "SEO-optimized AI generated blogs",
      icon: "https://d2z9497xp8xb12.cloudfront.net/prod-images/556715c1762866670753Group.svg"
    },
    {
      title: "AI Agents",
      description: "Answer, guide & perform task",
      icon: "https://d2z9497xp8xb12.cloudfront.net/prod-images/267761c1762866861598Frame_(2).svg"
    },
    {
      title: "Social Media",
      description: "Automated Social Media Management",
      icon: "https://dev-app.simpo.ai/assets/images/sidepanel/smm.svg"
    },
    {
      title: "CRM",
      description: "Track leads & manage customers efficiently",
      icon: "https://dev-app.simpo.ai/assets/images/sidepanel/crm.svg"
    },
    {
      title: "Invoicing",
      description: "Raise invoices & manage payments",
      icon: "https://dev-app.simpo.ai/assets/images/sidepanel/invoices.svg"
    },
    {
      title: "Sales",
      description: "Take your sales with you wherever you go",
      icon: "https://d2z9497xp8xb12.cloudfront.net/prod-images/470696c1763024887387Trending_up.svg"
    },
    {
      title: "Analytics",
      description: "Get business insights at your finger tips",
      icon: "https://d2z9497xp8xb12.cloudfront.net/prod-images/815601c1762866791252chart.svg"
    },
    {
      title: "Scheduling",
      description: "Schedule & manage appointments",
      icon: "https://d2z9497xp8xb12.cloudfront.net/prod-images/829469c1762793773234calendar.svg"
    }
  ];

  changeTab() {
    this.formType = FormType.SIGN_UP;
  }

}